import { jsxs, jsx } from 'react/jsx-runtime';
import '../Arrow/index.js';
import { StyledLink, StyledResponsiveImage, TitleContainer, Title, Author, Description, ReadMore } from './Plugins.styles.js';
import '../../hooks/index.js';
import { useTrackEventInView } from '../../hooks/useTrackEventInView.js';
import { useTrackEvent } from '../../hooks/useTrackEvent.js';
import Arrow from '../Arrow/Arrow.js';

/**
 *
 * Plugins
 *
 * This component renders the items for the Plugins section
 * in the Discover page.
 */
const Plugins = ({ title, content, image, links, author, }) => {
    // Analytics
    const { ref } = useTrackEventInView('DISCOVER - Plugins', {
        type: 'load',
        target: title,
    });
    const { trackEvent } = useTrackEvent();
    const link = links === null || links === void 0 ? void 0 : links[0];
    return (jsxs(StyledLink, Object.assign({ target: "_blank", variant: "secondary", href: link === null || link === void 0 ? void 0 : link.url, external: true, isUnderlined: true, onClick: () => trackEvent('DISCOVER - Plugins', {
            type: 'click',
            target: title,
        }) }, { children: [jsx(StyledResponsiveImage, { image: image, withSkeletonUI: true }), jsxs("div", Object.assign({ ref: ref }, { children: [jsxs(TitleContainer, { children: [jsx(Title, { children: title }), jsx(Author, { children: author })] }), jsx(Description, { children: content }), jsxs(ReadMore, { children: [link === null || link === void 0 ? void 0 : link.text, jsx(Arrow, {})] })] }))] })));
};

export { Plugins as default };
